import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Col,
    FormGroup,
    Label,
    Input,
    // Modal,
    // ModalHeader,
    // ModalBody,
    // ModalFooter,
    Table, // ✅ ใช้ Table จาก reactstrap
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import { Loading } from "../share/loading";
import * as Yup from "yup";
import "../share/form.css";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumberWithCommas } from "../share/NumberWithCommas";
import { useSearchParams, useNavigate } from "react-router-dom";
// import { NumericFormat } from 'react-number-format';
import { GetVMdDept } from "../share/api/MasterDataApi";
import { FormikSelect } from "../share/FormikSelect";
import { RenderCustomHeader } from "../share/RenderCustomHeader";
import { ConvertDateFormat } from "../share/ConvertDateFormat";
import { ConvertDateToThaiBuddhist } from "../share/ConvertDateToThaiBuddhist";
// import { CustomInputNumeric } from "../../share/CustomInputNumeric";
// import DataRegisterComponent from "../../share/DataRegisterComponent";
import Select from "react-select";
import { ReplaceNullWithEmptyString } from "../share/ReplaceNullWithEmptyString";

export function CreateSupportAnnounce7Component() {
    const navigate = useNavigate();
    const formikRef = useRef(null);

    const [searchParams] = useSearchParams();
    let supportId = searchParams.get("req");
    let supportTypeId = searchParams.get("type");
    const [currentSupportForm, setCurrentSupportForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"));
    const [listregisterOptions, setListRegisterOptions] = useState([]);
    const [selectRegisterId, setSelectRegisterId] = useState(0);
    // console.log("selectRegisterId", selectRegisterId);
    const [deptsData, setDeptsData] = useState([]);
    const [userProfile, setUserProfile] = useState(null);
    // console.log("user profile,", userProfile);
    const [userAuthRegister, setUserAuthRegister] = useState([]);
    // console.log("userAuthRegister", userAuthRegister);
    const [countTestLawOccupation, setCountLawOccupation] = useState(0);
    const [countLevelTestLawOccupation, setCountLevelTestLawOccupation] =
        useState(0);
    const [calculateAmount, setCalculateAmount] = useState(0);
    const [detailAnnounce7Data, setDetailAnnounce7Data] = useState([]);


    // จำนวนเงินต่อรายการ (เงื่อนไข)
    const [conditionOne, setConditionOne] = useState(null);
    const [conditionDate, setConditionDate] = useState(null);

    // ปี พ.ศ. แสดงใต้หัวข้อ
    const [selectYear, setSelectYear] = useState(null);

    // สมมติ data มาจาก API


    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading });
        getProfile();
    }, []);

    // useEffect(() => {
    //     checkStdSkill26();
    // }, []);

    const checkStdSkill26 = async () => {
        try {
            let res = await fetch(`api/SupportForm/checkStdSkill26/${userProfile?.customerNo}`);
            const resJson = await res.json();
            if (resJson?.status == 1) {
                // ✨ ดึงข้อมูลแล้ว map ให้มี field ที่ต้องกรอก (personTotal/employeeTotal)
                setDetailAnnounce7Data(
                    resJson?.dataenum?.map((row, i) => ({
                        id: row.id,
                        cer2Num: row.cer2Num, // เลขรมฐ2
                        careerName: row.careerName, // สาขาอาชีพ
                        occupationName: row.occupationName, // สาขา
                        occupationLevel: row.occupationLevel, // ระดับ
                        cer2ApproveDate: row.cer2ApproveDate, // วันที่ออก
                        personTotal: "", // ⭐ กรอกได้
                        employeeTotal: "", // ⭐ กรอกได้
                        // (ถ้ามีวันทดสอบในอนาคต สามารถเพิ่ม field certificateTestDate ได้)
                    }))
                );
            } else {
                Swal.fire({
                    icon: "warning",
                    title: `${resJson.message}`,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log("err", e);
        }
    };

    useEffect(() => {
        getProfile();
        checkStdSkill26();
        // checkDataAnnounce6()
    }, [selectRegisterId])

    useEffect(() => {
        const GetListRegister = async () => {
            try {
                const res = await fetch("/api/OfficerBorrowing/listRegister", {
                    method: "GET",
                    headers: { 'token': user.token },
                })
                const resJson = await res.json();
                setListRegisterOptions(resJson.dataenum);
            } catch (e) {
                // console.log("err", e)
            }
        }
        GetListRegister();
    }, [])


    // สมมติ data มาจาก API
    const registerOptions = (listregisterOptions || []).map((x) => ({
        value: x.registerId, // เก็บค่า registerId
        // label: `${x.companyNo ?? "-"} | ${x.customerNo ?? "-"} | ${x.fullName ?? "-"}`,
        label: `${x.fullName ?? "-"}`,

        companyNo: x.companyNo ?? "",
        customerNo: x.customerNo ?? "",
        fullName: x.fullName ?? "",
    }));
    const toText = (v) => (v ?? "").toString().toLowerCase();

    const customFilter = (option, rawInput) => {
        const q = toText(rawInput);
        const d = option && option.data ? option.data : {};
        return [d.companyNo, d.customerNo, d.fullName].some((f) => toText(f).includes(q));
    };

    const getProfile = async () => {
        try {
            let formData = new FormData();
            formData.append("registerId", selectRegisterId ?? 0)
            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { token: user.token },
                body: formData

            });
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);

            if (supportId == "0") {
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
                formikRef.current?.setFieldValue(
                    "coordinateName",
                    resJson.dataenum.contactorName
                );
                formikRef.current?.setFieldValue(
                    "coordinatePhone",
                    resJson.dataenum.contactorPhone
                );
                formikRef.current?.setFieldValue(
                    "coordinateMobile",
                    resJson.dataenum.phone
                );
                formikRef.current?.setFieldValue("coordinateFax", resJson.dataenum.fax);
                formikRef.current?.setFieldValue("coordinateEmail", resJson.dataenum.email);
            }
        } catch (e) {
            // console.log("err", e);
        }
    };

    // ดึงข้อมูลแบบฟอร์มอุดหนุน
    useEffect(() => {
        const GetCurrentSupportForm = async () => {
            if (supportId !== "0") {
                let postData = new FormData();
                postData.append("supportId", Number(supportId));
                postData.append("supportTypeId", Number(supportTypeId));
                setLoading(true);
                try {
                    let res = await fetch("/api/SupportForm/getSupportFormData", {
                        method: "POST",
                        body: postData,
                    });
                    let resJson = await res.json();
                    resJson.dataenum["customerTypeId"] = Number(user.roldId);
                    resJson.dataenum["registerId"] = Number(user.registerId);
                    resJson.dataenum["announce"] = "7";
                    resJson.dataenum["term"] = true;
                    setCurrentSupportForm(ReplaceNullWithEmptyString(resJson.dataenum));
                    setDetailAnnounce7Data(resJson.dataenum.dataAnnounce7 || []);
                } catch (e) {
                    // ignore
                } finally {
                    setLoading(false);
                }
            }
        };
        GetCurrentSupportForm();
    }, []);

    // คำนวณยอด/ปี/จำนวนสาขา-ระดับ
    useEffect(() => {
        async function calculateAmountSupport() {
            setLoading(true);
            try {
                // ปีอ้างอิงจากวันที่อนุมัติหนังสือรับรอง รมฐ.2 (ถ้ามีค่า)
                if (detailAnnounce7Data.length && detailAnnounce7Data[0].cer2ApproveDate) {
                    const y = String(detailAnnounce7Data[0].cer2ApproveDate).substring(0, 4);
                    setSelectYear(y);
                } else {
                    setSelectYear(null);
                }

                setCountLawOccupation(detailAnnounce7Data.length);
                setCountLevelTestLawOccupation(detailAnnounce7Data.length);

                let calculate =
                    detailAnnounce7Data.length > 0 && Number(conditionOne)
                        ? detailAnnounce7Data.length * Number(conditionOne)
                        : 0;
                setCalculateAmount(calculate);
            } catch {
                // ignore
            } finally {
                setLoading(false);
            }
        }
        calculateAmountSupport();
    }, [detailAnnounce7Data, conditionOne]);

    // เงื่อนไข (เช่น rate/จำนวนวัน)
    useEffect(() => {
        const getCondition = async () => {
            try {
                let res = await fetch(`api/SupportForm/getConditionSupport/${6}`);
                let resJson = await res.json();
                resJson.dataenum?.forEach((condition) => {
                    setConditionOne(condition.condition1);
                    setConditionDate(condition.conditionDate);
                });
            } catch (e) {
                // console.log("err => ", e);
            }
        };
        getCondition();
    }, []);

    const authRegisterOptions =
        userAuthRegister?.map((item) => ({
            label: `${item.authFullName} `,
            value: item.authRegisterId,
        })) || [];

    const initialValues = {
        supportId: "0",
        registerId: Number(user.registerId),
        supportTypeName: "ผู้ประกอบกิจการ/ผู้ประกอบอาชีพ/กลุ่มผู้ประกอบกิจการ",
        detailAnnounce7Ar: detailAnnounce7Data,
        supportTypeId: "6",
        announce: "7",
        authRegisterId: 0,
        deptId: "",
        supportName: "",
        customerTypeId: Number(user.roldId),
        employeeAmount: "",
        amount: calculateAmount,
        paymentName: "",
        // skillStandardCertNoRmth3: "",
        fOtherPath: "",
        fSsoPath: "",
        fCertificateTest: "",
        fEmployeeCertTotal: "",
        term: false,
    };

    const onSubmit = async (values) => {
        if (calculateAmount !== 0) {
            // ตรวจ 90 วัน เฉพาะรายการที่มี certificateTestDate เท่านั้น (ถ้าไม่มีให้ข้าม)
            let pass = true;
            detailAnnounce7Data.forEach((item) => {
                if (item.certificateTestDate) {
                    const diffMs = new Date() - new Date(item.certificateTestDate);
                    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                    if (Number(conditionDate) && diffDays > Number(conditionDate)) {
                        pass = false;
                    }
                }
            });

            if (!pass) {
                Swal.fire({
                    icon: "warning",
                    title: `ไม่สามารถบันทึกข้อมูลได้`,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: `เนื่องจากมีบางรายการ วันที่ดำเนินการทดสอบ มีจำนวนมากกว่า ${conditionDate} วัน`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
                return;
            }

            let postData = new FormData();
            postData.append("amount", calculateAmount);
            Object.entries(values).forEach(([key, value]) => {
                if (key.endsWith("7Ar")) {
                    postData.append(key, JSON.stringify(detailAnnounce7Data));
                } else {
                    postData.append(key, value);
                }
            });

            try {
                let res = await fetch("/api/SupportForm/saveSupportForm", {
                    method: "POST",
                    body: postData,
                });

                let resJson = await res.json();

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate("/supporting/");
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                // console.log(e);
            }
        } else {
            Swal.fire({
                icon: "info",
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                allowOutsideClick: false,
                allowEscapeKey: false,
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
        }
    };

    const validationSchema = Yup.object().shape({
        // skillStandardCertNoRmth3: Yup.string().required(""),
        fOtherPath: Yup.mixed().when("file", {
            is: (value) => value !== undefined && value !== null,
            then: Yup.mixed()
                .test(
                    "fileFormat",
                    "กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg",
                    (value) =>
                        value && ["application/pdf", "image/jpg", "image/jpeg"].includes(value.type)
                )
                .test("fileSize", "ขนาดไฟล์ต้องไม่เกิน 1MB", (value) => {
                    const maxSize = 1000000;
                    return !value || value.size <= maxSize;
                }),
        }),
        fSsoPath: Yup.mixed().when("supportId", {
            is: (supportId) => supportId === "0",
            then: Yup.mixed()
                .required("กรุณาแนบไฟล์")
                .test(
                    "fileFormat",
                    "กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg",
                    (value) =>
                        value && ["application/pdf", "image/jpg", "image/jpeg"].includes(value.type)
                )
                .test("fileSize", "ขนาดไฟล์ต้องไม่เกิน 1MB", (value) => {
                    const maxSize = 1000000;
                    return !value || value.size <= maxSize;
                }),
            otherwise: Yup.mixed(),
        }),
        fCertificateTest: Yup.mixed().when("supportId", {
            is: (supportId) => supportId === "0",
            then: Yup.mixed()
                .required("กรุณาแนบไฟล์")
                .test(
                    "fileFormat",
                    "กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg",
                    (value) =>
                        value && ["application/pdf", "image/jpg", "image/jpeg"].includes(value.type)
                )
                .test("fileSize", "ขนาดไฟล์ต้องไม่เกิน 1MB", (value) => {
                    const maxSize = 1000000;
                    return !value || value.size <= maxSize;
                }),
            otherwise: Yup.mixed(),
        }),
        fEmployeeCertTotal: Yup.mixed().when("supportId", {
            is: (supportId) => supportId === "0",
            then: Yup.mixed()
                .required("กรุณาแนบไฟล์")
                .test(
                    "fileFormat",
                    "กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg",
                    (value) =>
                        value && ["application/pdf", "image/jpg", "image/jpeg"].includes(value.type)
                )
                .test("fileSize", "ขนาดไฟล์ต้องไม่เกิน 1MB", (value) => {
                    const maxSize = 1000000;
                    return !value || value.size <= maxSize;
                }),
            otherwise: Yup.mixed(),
        }),
        deptId: Yup.string().required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),
        paymentName: Yup.string().required("กรุณากรอกข้อมูล"),
        term: Yup.bool().oneOf([true], "กรุณายอมรับข้อตกลง"),
    });

    // ✅ อัปเดตรายการในตารางเมื่อพิมพ์ตัวเลข
    const updateRow = (index, field, rawValue) => {
        const value = rawValue === "" ? "" : String(rawValue).replace(/[^\d]/g, "");
        setDetailAnnounce7Data((prev) => {
            const next = [...prev];
            next[index] = { ...next[index], [field]: value };
            return next;
        });
    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={supportId === "0" ? initialValues : currentSupportForm}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={supportId === "0" ? false : true}
        >
            {({ setFieldValue, values, touched, errors, handleBlur, handleChange }) => {

                const findPersonalId = () => {
                    if (values.authRegisterId != 0) {
                        const found = userAuthRegister.find(item => item.authRegisterId == values.authRegisterId);
                        return found.authPersonalId
                    }
                }
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border-">
                                <Form className="p-5 mb-4">
                                    <Label style={{ fontWeight: "bold" }} className="customer-type text-center px-5">
                                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                        พ.ศ. 2545 กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                    </Label>
                                    <FormGroup className="mb-3">
                                        <Label htmlFor="establishmentId" className="fw-semibold">
                                            เลือกผู้ใช้งานที่จะลงทะเบียนให้ <span className="require-input">*</span>
                                        </Label>

                                        <Select
                                            options={registerOptions}
                                            filterOption={customFilter}
                                            placeholder="ค้นหาโดย เลขทะเบียนนิติบุคคล 13 หลัก, เลขสถานประกอบการ 10 หลัก หรือ ชื่อสถานประกอบการ"
                                            isClearable
                                            noOptionsMessage={() => "ไม่พบข้อมูล"}
                                            onChange={(selected) => {
                                                // console.log("selected.value", selected.value);
                                                // selected = { value, label, companyNo, customerNo, fullName }
                                                setSelectRegisterId(selected.value)
                                                setFieldValue("registerId", selected ? selected.value : "");
                                            }}
                                            value={registerOptions.find(item => item.value == selectRegisterId)}
                                        />
                                    </FormGroup>
                                    {/* ปุ่มลงทะเบียนใหม่ */}
                                    {/* <div className="d-flex align-items-center mt-2">
                                        <span className="me-3 text-muted">
                                            หากยังไม่ได้ลงทะเบียนสถานประกอบการในระบบ
                                        </span>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary rounded-pill px-4"
                                            onClick={() => navigate("/register-establishment")} // 🔧 route ปรับตามจริง
                                        >
                                            ลงทะเบียน
                                        </button>
                                    </div> */}
                                    {/* <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label> */}

                                    <FormGroup className="mt-3">
                                        <Label>ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                onBlur={handleBlur}
                                                value={userProfile?.entrepreneurName ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>

                                    <FormGroup className="mt-3">
                                        <Label>เลขทะเบียนนิติบุคคล</Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                onBlur={handleBlur}
                                                value={userProfile?.customerNo ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>

                                    <FormGroup className="mt-3">
                                        <Label>ประเภทกิจการ</Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                onBlur={handleBlur}
                                                value={userProfile?.businessType ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>

                                    {/* หน่วยงาน */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ยื่นคำขอที่<span className="require-input">*</span>
                                            {touched.deptId && errors.deptId ? (
                                                <span className="text-left text-danger mx-1">{errors.deptId}</span>
                                            ) : null}
                                        </Label>
                                        <Col>
                                            <Field
                                                name="deptId"
                                                component={FormikSelect}
                                                options={deptsData}
                                                placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                            />
                                        </Col>
                                    </FormGroup>

                                    {/* ผู้มีอำนาจ */}
                                    <FormGroup row>
                                        <Label for="titleId">
                                            โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                            <span className="require-input">*</span>
                                            {touched.authRegisterId && errors.authRegisterId ? (
                                                <span className="text-left text-danger px-1">{errors.authRegisterId}</span>
                                            ) : null}
                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Field
                                                    name="authRegisterId"
                                                    component={FormikSelect}
                                                    options={authRegisterOptions}
                                                    placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                                                />
                                            </div>
                                        </div>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="titleId">
                                            เลขบัตรประจำตัวประชาชน

                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Input
                                                    className="rounded-pill text-center input-color"
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    disabled
                                                    value={findPersonalId()}
                                                />

                                            </div>
                                        </div>
                                    </FormGroup>

                                    {/* จำนวนลูกจ้างรวม */}
                                    <Label for="employeeAmount">
                                        จำนวนลูกจ้าง
                                        <span className="require-input">*</span>
                                        {touched.employeeAmount && errors.employeeAmount ? (
                                            <span className="text-left text-danger mx-1">{errors.employeeAmount}</span>
                                        ) : null}
                                    </Label>
                                    <Col>
                                        <Input
                                            className={
                                                touched.employeeAmount && errors.employeeAmount
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            type="text"
                                            name="employeeAmount"
                                            id="employeeAmount"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={values?.employeeAmount}
                                        />
                                    </Col>

                                    {/* ผู้ประสานงาน */}
                                    <FormGroup className="mt-3">
                                        <Label>ชื่อผู้ประสานงาน</Label>
                                        <Col>
                                            <Input
                                                className={
                                                    touched.coordinateName && errors.coordinateName
                                                        ? "input-error rounded-pill text-center input-color"
                                                        : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="coordinateName"
                                                id="coordinateName"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                disabled
                                                value={values?.coordinateName}
                                            />
                                        </Col>
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label for="coordinatePhone" sm={2}>
                                                    โทรศัพท์<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinatePhone"
                                                        name="coordinatePhone"
                                                        type="text"
                                                        className={
                                                            touched.coordinatePhone && errors.coordinatePhone
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        disabled
                                                        value={values?.coordinatePhone}
                                                    />
                                                </Col>

                                                <Label for="coordinateMobile" sm={2}>
                                                    โทรศัพท์มือถือ<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateMobile"
                                                        name="coordinateMobile"
                                                        type="text"
                                                        className={
                                                            touched.coordinateMobile && errors.coordinateMobile
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        disabled
                                                        value={values?.coordinateMobile}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label sm={2}>โทรสาร</Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateFax"
                                                        name="coordinateFax"
                                                        type="text"
                                                        className={
                                                            touched.coordinateFax && errors.coordinateFax
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        disabled
                                                        value={values?.coordinateFax}
                                                    />
                                                </Col>

                                                <Label for="coordinateEmail" sm={2}>
                                                    อีเมล<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateEmail"
                                                        name="coordinateEmail"
                                                        type="text"
                                                        className={
                                                            touched.coordinateEmail && errors.coordinateEmail
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        disabled
                                                        value={values?.coordinateEmail}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>

                                    {/* ปี พ.ศ. */}
                                    <FormGroup className="d-flex justify-content-start align-items-center">
                                        <Label>
                                            ปี พ.ศ.{" "}
                                            {selectYear ? Number(selectYear) + 543 : <span>{"........."}</span>} ที่ได้รับการรับรองมาตรฐานฝีมือแรงงานตามมาตรา 26
                                        </Label>
                                    </FormGroup>
                                    <Label>และได้นำมาตรฐานฝีมือแรงงานดังกล่าวไปใช้ในการทดสอบให้แก่ลูกจ้างของตนภายใน 1 ปีนับแต่วันที่ได้รับการรับรอง ดังนี้</Label>

                                    {/* ✅ ตารางแก้ไขค่าได้ทันที */}
                                    <FormGroup className="mt-3">
                                        <Table bordered responsive>
                                            <thead className="text-center">
                                                <tr>
                                                    <th style={{ width: 60 }}>ลำดับ</th>
                                                    <th>เลขรมฐ.2</th>
                                                    <th>สาขาอาชีพ</th>
                                                    <th>สาขา</th>
                                                    <th style={{ width: 120 }}>ระดับ</th>
                                                    <th style={{ width: 140 }}>วันที่ออก</th>
                                                    <th style={{ width: 180 }}>จำนวนลูกจ้างที่ทดสอบ</th>
                                                    <th style={{ width: 220 }}>จำนวนลูกจ้างในตำแหน่งงาน</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detailAnnounce7Data.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={8} className="text-center">
                                                            ไม่พบข้อมูล
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    detailAnnounce7Data.map((row, idx) => (
                                                        <tr key={row.id || idx}>
                                                            <td className="text-center">{idx + 1}</td>
                                                            <td className="text-center">{row.cer2Num || "-"}</td>
                                                            <td className="text-center">{row.careerName || "-"}</td>
                                                            <td className="text-center">{row.occupationName || "-"}</td>
                                                            <td className="text-center">{row.occupationLevel || "-"}</td>
                                                            <td className="text-center">
                                                                {row.cer2ApproveDate
                                                                    ? ConvertDateToThaiBuddhist(row.cer2ApproveDate)
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="number"
                                                                    min="0"
                                                                    className="rounded-pill text-center input-color"
                                                                    value={row.personTotal}
                                                                    onChange={(e) => updateRow(idx, "personTotal", e.target.value)}
                                                                    placeholder="กรุณาระบุ"
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="number"
                                                                    min="0"
                                                                    className="rounded-pill text-center input-color"
                                                                    value={row.employeeTotal}
                                                                    onChange={(e) =>
                                                                        updateRow(idx, "employeeTotal", e.target.value)
                                                                    }
                                                                    placeholder="กรุณาระบุ"
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </Table>
                                    </FormGroup>

                                    {/* ความประสงค์และยอดรวม */}
                                    <FormGroup className="mt-3">
                                        <Label>
                                            มีความประสงค์ขอรับเงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                            พ.ศ. 2545 รวมจำนวน {countTestLawOccupation} สาขา จำนวน {countLevelTestLawOccupation} ระดับ เป็นเงินทั้งสิ้นจำนวน
                                            <span className="require-input">*</span>
                                        </Label>
                                        <Input
                                            type="text"
                                            disabled={true}
                                            className="rounded-pill text-center input-color"
                                            value={NumberWithCommas(calculateAmount)}
                                        />
                                    </FormGroup>

                                    {/* เช็คขีดคร่อมสั่งจ่ายในนาม */}
                                    <FormGroup>
                                        <Label>
                                            โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                            <span className="require-input">*</span>
                                            {touched.paymentName && errors.paymentName ? (
                                                <span className="text-left text-danger px-1">{errors.paymentName}</span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="paymentName"
                                            name="paymentName"
                                            type="text"
                                            className={
                                                touched.paymentName && errors.paymentName
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values?.paymentName}
                                        />
                                    </FormGroup>

                                    {/* อัปโหลดไฟล์ */}
                                    <FormGroup>
                                        <Label for="fSsoPath">
                                            แบบแสดงการส่งเงินสมทบ (สปส.1-10) ณ เดือนที่ดำเนินการทดสอบ
                                            <span className="require-input mx-2">*</span>
                                            {errors.fSsoPath && touched.fSsoPath ? (
                                                <span className="mx-2 text-danger">{errors.fSsoPath}</span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="fSsoPath"
                                            name="fSsoPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fSsoPath", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            หนังสือรับรองว่าเป็นผู้ผ่านการทดสอบมาตรฐานฝีมือแรงงาน ตามมาตรา 26 (แบบ รมฐ.3)
                                            <span className="require-input mx-2">*</span>
                                            {errors.fCertificateTest && touched.fCertificateTest ? (
                                                <span className="mx-2 text-danger">{errors.fCertificateTest}</span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="fCertificateTest"
                                            name="fCertificateTest"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fCertificateTest", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            เอกสารที่แสดงจำนวนลูกจ้างทั้งหมดในตำแหน่งงานที่ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน ตามมาตรา 26
                                            <span className="require-input mx-2">*</span>
                                            {errors.fEmployeeCertTotal && touched.fEmployeeCertTotal ? (
                                                <span className="mx-2 text-danger">{errors.fEmployeeCertTotal}</span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="fEmployeeCertTotal"
                                            name="fEmployeeCertTotal"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fEmployeeCertTotal", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>เอกสารอื่นๆ (ถ้ามี)</Label>
                                        <Input
                                            id="fOtherPath"
                                            name="fOtherPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fOtherPath", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup>

                                    {/* term */}
                                    <div className="d-flex">
                                        <Input
                                            type="checkbox"
                                            name="term"
                                            id="term"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values?.term}
                                            checked={values?.term}
                                        />
                                        <Label for="term" className="mx-2 customer-type">
                                            ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                        </Label>
                                    </div>

                                    <div className="d-flex justify-content-center align-items-center mt-5">
                                        <button
                                            type="submit"
                                            className="btn-blue px-4 w-25"
                                            disabled={values?.term ? false : true}
                                        >
                                            ส่งคำขอ
                                        </button>
                                    </div>
                                </Form>
                            </div>
                        ) : (
                            <Loading />
                        )}
                    </Container>
                );
            }}
        </Formik>
    );
}
